"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KegChangeSchema = exports.KegChangeInitialized = void 0;
const joi_1 = __importDefault(require("joi"));
const joiMessages_1 = require("../data/joiMessages");
exports.KegChangeInitialized = {
    numberOfKegs: 0,
    oldNumberOfKegs: 0,
    reasonFlex: '',
    reason: '',
    placeName: '',
    customerEmail: '',
    customerNotes: '',
};
exports.KegChangeSchema = joi_1.default.object({
    numberOfKegs: joi_1.default.number().messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Number of kegs' }),
    }),
    oldNumberOfKegs: joi_1.default.number().messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Old number of kegs' }),
    }),
    reason: joi_1.default.string()
        .optional()
        .allow('')
        .max(700)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Reason' }),
    }),
    reasonFlex: joi_1.default.string()
        .optional()
        .allow('')
        .max(1000)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Detailed reason' }),
    }),
    placeName: joi_1.default.string()
        .optional()
        .allow('')
        .max(1000)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Place name' }),
    }),
    customerEmail: joi_1.default.string()
        .optional()
        // .email()
        .allow('')
        .max(400)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Customer email' }),
    }),
    customerNotes: joi_1.default.string()
        .optional()
        .allow('')
        .max(2000)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Customer notes' }),
    }),
});
